import { render, staticRenderFns } from "./ScriptManager.vue?vue&type=template&id=56f410b1&"
import script from "./ScriptManager.vue?vue&type=script&lang=ts&"
export * from "./ScriptManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports